module.exports = __webpack_public_path__ + "static/logo-bar-s-food-sigma-8c83593f4f11ef5a2b666db6385cc1d0.png";